import { MatDialogConfig } from '@angular/material/dialog';
import { CreateOrderDialogData } from './create-order.component';

/**
 * CSS class name applied to Material Dialog panel for Order of Service creation dialogs.
 */
export const CREATE_ORDER_PANEL_CLASS: string = 'create-order-panel';

/**
 * Builds Material Dialog configuration for Order of Service creation dialog.
 *
 * Description:
 *   Configures width, panelClass, and data payload for the CreateOrderComponent modal dialog.
 *
 * Parameters:
 *   dialogDataPayload: CreateOrderDialogData - Data payload containing service IDs or items.
 *   dialogOptions: { disableClose?: boolean } - Additional configuration options such as disableClose.
 *
 * Return Value:
 *   MatDialogConfig<CreateOrderDialogData> - Configured MatDialogConfig object.
 *
 * Exceptions & Errors:
 *   None.
 */
export function buildCreateOrderDialogConfig(
  dialogDataPayload: CreateOrderDialogData,
  dialogOptions?: { disableClose?: boolean },
): MatDialogConfig<CreateOrderDialogData> {
  return {
    width: '520px',
    maxWidth: '94vw',
    panelClass: CREATE_ORDER_PANEL_CLASS,
    autoFocus: false,
    disableClose: dialogOptions?.disableClose ?? false,
    data: dialogDataPayload,
  };
}
